export const ORDER_ITEM_CHECKBOX_DATA_TEST_ID = 'order-item-checkbox';
